import apiClient from "../client";

// GET /api/associates/scg-pool/stats
// Returns: { inPool, fullyFree, partial, freeFte, over30Days }
export const getScgPoolStats = async () => {
  const response = await apiClient.get("/associates/scg-pool/stats");
  return response.data;
};

// GET /api/associates/scg-pool?filter=fullyfree|over30days  (omit for all)
// Returns: ScgPoolDto[]
export const getScgPool = async (params = {}) => {
  const cleanParams = {};
  // Only pass filter if it's not "all" — omit sends all
  if (params.filter && params.filter !== "all") {
    cleanParams.filter = params.filter;
  }
  const response = await apiClient.get("/associates/scg-pool", { params: cleanParams });
  return response.data;
};

export const updatePipStatus = async (associateId, isInPip) => {
  const response = await apiClient.patch(`/associates/${associateId}/pip`, { isInPip });
  return response.data;
};